import type {
  AgeBand,
  AstroSummary,
  ConnectionIntent,
  LifeStage,
  LocaleId,
  MatchingRegion,
  UserScoreProfileDoc,
} from '@astrally/shared';

/**
 * Everything the matching engine needs to know about one user, assembled by
 * the caller (Firebase Function or demo seed) from `users/{uid}`,
 * `userScores/{uid}` and the synced astro summary.
 *
 * Note what is NOT here: exact birth data, raw memories, message content.
 */
export interface MatchableProfile {
  uid: string;
  displayName: string;
  ageBand: AgeBand;
  region: string;
  city?: string;
  languages: LocaleId[];
  intents: ConnectionIntent[];
  interests: string[];
  lifeStage?: LifeStage;
  /**
   * Which kundli tradition grades matches when THIS profile is the seeker.
   * Absent means DEFAULT_MATCHING_REGION ('north' → Ashtakoota). Read only off
   * the seeker: `computeCompatibility(a, b)` uses `a.matchingRegion` and
   * ignores `b`'s, because the score is being rendered to `a`.
   */
  matchingRegion?: MatchingRegion;
  dimensions: UserScoreProfileDoc['dimensions'];
  /** 0..1 — server-maintained; low trust is a hard-filter concern. */
  trustLevel: number;
  astro?: AstroSummary;
  discoverable: boolean;
  recommendationsPaused: boolean;
  ageConfirmed: boolean;
}

export function pairIdOf(aUid: string, bUid: string): string {
  return [aUid, bUid].sort().join('_');
}
